export { useCoupon } from './useCoupon';
export { REFERRAL_NOT_FOUND_RESPONSE_DATA } from './utils/getCoupon';
export { useSetCouponCookie } from './useSetCouponCookie';
export { useSetPromotion } from './useSetPromotion';
export { couponCookie } from './utils/couponCookie';
export { getDiscountBannerCopy } from './getDiscountBannerCopy';
export type { GetDiscountBannerCopyArgs } from './getDiscountBannerCopy';
export { formatDiscountAmount } from './formatDiscountAmount';
export * from './types';
export {
  isShadowing,
  isContextPrimary,
  compareShadow,
  logShadowMismatch,
  PromotionCapture,
  useShadowComparison,
} from './shadow';
export type {
  PromotionContextTreatment,
  ShadowComparisonResult,
  LogFn,
} from './shadow';
export type { UseCouponReturn } from './useCoupon';
export { configureCoupons, getCouponsConfig } from './config';
export type { CouponsConfig } from './config';
export { PromotionProvider, usePromotion } from './context';
export type {
  PromotionContextValue,
  PromotionState,
  PromotionActions,
  SetPromotionArgs,
  PromotionProviderProps,
} from './context';
export { defaultPromotionContextValue } from './test-utils';
